export enum ESetupTabOptions {
  General = 0,
  Ingredients = 1,
  PlateTypes = 2,
  DispenseProperties = 3,
  Imaging = 4,
  CrystalContainer = 5,
}

export const sideTabs = [
  { key: ESetupTabOptions.General, value: 'general' },
  { key: ESetupTabOptions.Ingredients, value: 'ingredients' },
  { key: ESetupTabOptions.PlateTypes, value: 'platetypes' },
  { key: ESetupTabOptions.DispenseProperties, value: 'dispenseproperties' },
  { key: ESetupTabOptions.Imaging, value: 'imaging' },
  { key: ESetupTabOptions.CrystalContainer, value: 'crystalcontainer' },
];
